module.exports = __webpack_public_path__ + "static/5-dc2d2602ec54e713b713942b04b5f6c4.jpg";